import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

export type SpinnerSize = 'small' | 'large';

@Component({
  selector: 'ticketing-loading-indicator',
  imports: [NgClass],
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingIndicatorComponent {
  size = input<SpinnerSize>('large');
}
